import {ProjectSortField} from '@contentlab/stores/projectsStore';
import {FeatureName} from '@contentlab/types/project';
import getFeatureIconName from '@contentlab/utils/getFeatureIconName';

export const ASSETS_SORT_OPTION = {
  STATUS: {
    id: 'status',
    field: ProjectSortField.STATUS,
    direction: 'desc',
    labelLocaleKey: 'Status',
    icon: 'Features-Duration',
  },
  ALPHABETICAL: {
    id: 'fileName',
    field: ProjectSortField.FILE_NAME,
    direction: 'asc',
    labelLocaleKey: 'Alphabetical',
    icon: 'Navigation-Arrow-Down-Up',
  },
  LANGUAGE: {
    id: 'language',
    field: ProjectSortField.LANGUAGE,
    direction: 'desc',
    labelLocaleKey: 'Language',
    icon: getFeatureIconName(FeatureName.AI_DUBBING),
  },
  ASPECT_RATIO: {
    id: 'aspectRatio',
    field: ProjectSortField.ASPECT_RATIO,
    direction: 'asc',
    labelLocaleKey: 'Aspect ratio',
    icon: getFeatureIconName(FeatureName.REFORMATTING),
  },
  RESOLUTION: {
    id: 'resolution',
    field: ProjectSortField.RESOLUTION,
    direction: 'desc',
    labelLocaleKey: 'Resolution',
    icon: getFeatureIconName(FeatureName.UPSCALE),
  },
};

export const FEATURE_SORT_OPTION = {
  [FeatureName.AI_DUBBING]: [
    ASSETS_SORT_OPTION.ALPHABETICAL,
    ASSETS_SORT_OPTION.LANGUAGE,
  ],
  [FeatureName.REFORMATTING]: [
    ASSETS_SORT_OPTION.ALPHABETICAL,
    ASSETS_SORT_OPTION.ASPECT_RATIO,
  ],
  [FeatureName.CAPTIONS]: [ASSETS_SORT_OPTION.ALPHABETICAL],
  [FeatureName.AI_AVATAR]: [ASSETS_SORT_OPTION.ALPHABETICAL],
  [FeatureName.UPSCALE]: [
    ASSETS_SORT_OPTION.ALPHABETICAL,
    ASSETS_SORT_OPTION.RESOLUTION,
  ],
};
